import { defineComponent as _defineComponent } from 'vue'
import ChevronIcon from '@/icons/ChevronIcon.vue';
import { Column, ISortConfig } from './types';

export interface TableHeaderProps {
    currentSort?: ISortConfig;
    onSort?: (page: number, sort: ISortConfig) => void;
    columns: Column[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableHeader',
  props: {
    currentSort: null,
    onSort: null,
    columns: null
  },
  setup(__props: any) {

const props = __props as {
    currentSort?: ISortConfig;
    onSort?: (page: number, sort: ISortConfig) => void;
    columns: Column[];
};



const getClasses = (column: Column, isLast: boolean) => {
    return `card-col ${column.isSortable ? 'sortable' : ''} ${isLast ? 'row-end' : ''}`;
};

const handleSort = (key: string) => {
    props.onSort(1, {
        col: key,
        dir: props.currentSort.dir === "asc" ? "desc" : "asc"
    });
};


return { __sfc: true,props, getClasses, handleSort, ChevronIcon }
}

})